// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"19ff0422","124":"d5198d68","353":"1a1aeadd","453":"87e45203","660":"f822747f","697":"936618de","747":"3c704384","819":"d3b2aee9","822":"e27549f3","850":"47a8fce7","890":"3610c6f2"}[chunkId] + ".chunk.js";
};